import React, { useEffect, useState } from 'react';

function ServicesSliderNew() {
  const [currentServiceSlide, setCurrentServiceSlide] = useState(0);
  const projectImageBase = "/assets/RIPL%20Projects";

  const services = [
    {
      number: "01",
      label: "CONSTRUCTION",
      title: "Building",
      titleAccent: "Foundations",
      description: "Construction for us is not just about building apartments, It is the process of creating a design that lives to one's expectation, building a foundation that is deeply rooted in trust, and developing an environment full of peace and happiness. It is the art of building a place called home. We do it all from commercial to residential and from the public to Utility infrastructures.",
      tag: "Commercial \u2022 Residential \u2022 Public Infrastructure",
      image: `${projectImageBase}/Construction/LIC%20Mixed%20Use%20Development,%20Vadodara,%20Gujarat/4.png`
    },
    {
      number: "02",
      label: "INTERIOR",
      title: "Design",
      titleAccent: "Excellence",
      description: "We strongly believe that interiors have a strong influence on the ambience of a room or even the entire house/office. The essence of any interior design will always be about people and how they live. It is about the realities of what makes for an attractive, civilized, meaningful environment, not about fashion or what's in or what's out. We believe in rejuvenating interiors to breathe fresh life into them and creating warm and beautiful spaces.",
      tag: "Residential \u2022 Commercial \u2022 Office Spaces",
      image: `${projectImageBase}/Interiors/SBI%20Reception%20Lobby,%20State%20Bank%20Bhavan,%20Mumbai/3.png`
    },
    {
      number: "03",
      label: "UTILITIES",
      title: "Infrastructure",
      titleAccent: "Services",
      description: "Extensive infrastructure with routine updating and maintenance. providing all necessary infrastructure needs, basic amenities, such as water, sewage services, electricity, dams, and natural gas. As they are part of the public service landscape and are therefore heavily regulated. As we mentioned before we do it all!",
      tag: "Water \u2022 Electricity \u2022 Sewage \u2022 Gas Infrastructure",
      image: `${projectImageBase}/Construction/Tourist%20Infrastructure%20Facilities,%20Kanheri%20Caves,%20Mumbai/8.png`
    },
    {
      number: "04",
      label: "UPGRADATION",
      title: "Modernization",
      titleAccent: "Services",
      description: "Let's give your structure a sigh of life and recreate the magic that it had years ago. the process of improving the quality of living, Making things better and contribute towards building a developing society.",
      tag: "Renovation \u2022 Retrofitting \u2022 Modernization",
      image: `${projectImageBase}/Retrofitting/State%20Bank%20Bhavan,%20Nariman%20Point,%20Mumbai/2.png`
    },
    {
      number: "05",
      label: "PROJECT MANAGEMENT",
      title: "Professional",
      titleAccent: "Management",
      description: "Allow our staff to provide you with a professional and quality approach to our projects. Quality assurance is also guaranteed! These specialized Project Management services help guide our clients through projects efficiently with expert advice and support during every phase.",
      tag: "Quality Assurance \u2022 Expert Guidance \u2022 Support",
      image: `${projectImageBase}/Interiors/SBI%20General%20Insurance,%20Thane/7.png`
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentServiceSlide((prev) => (prev + 1) % services.length);
    }, 6000);

    return () => clearInterval(interval);
  }, [services.length]);

  const nextServiceSlide = () => {
    setCurrentServiceSlide((prev) => (prev + 1) % services.length);
  };

  const prevServiceSlide = () => {
    setCurrentServiceSlide((prev) => (prev - 1 + services.length) % services.length);
  };

  const percentage = ((currentServiceSlide + 1) / services.length) * 100;
  const nextServiceSlideIndex = (currentServiceSlide + 1) % services.length;

  return (
    <section id="services" className="services-slider-container">
      {services.map((service, index) => (
        <div
          key={index}
          className={`service-slide ${currentServiceSlide === index ? 'active' : ''}`}
        >
          <div
            className="service-slide-img"
            style={
              index === currentServiceSlide || index === nextServiceSlideIndex
                ? { backgroundImage: `url('${service.image}')` }
                : undefined
            }
          ></div>
          <div className="service-slide-content">
            <div className="service-slide-text">
              <span className="mb-4 block bank-gothic text-xs tracking-[0.4em] text-neutral-500">
                {service.number} / {service.label}
              </span>
              <h3 className="bank-gothic mb-6 text-3xl leading-tight text-white md:text-4xl">
                {service.title} <br />
                <span className="accent-text">{service.titleAccent}</span>
              </h3>
              <p className="mb-8 max-w-md text-xs font-light leading-relaxed text-neutral-400 md:text-sm">
                {service.description}
              </p>
              <span className="block bank-gothic text-[9px] tracking-[0.2em] text-neutral-600">
                {service.tag}
              </span>
            </div>
          </div>
        </div>
      ))}

      <div className="absolute bottom-4 left-5 right-5 z-20 flex flex-col gap-4 sm:left-6 sm:right-6 sm:flex-row sm:items-center sm:justify-between md:bottom-8 md:left-auto md:right-8">
        <div className="flex items-center space-x-2">
          <span className="bank-gothic text-[10px] text-[#c49b66]">
            {String(currentServiceSlide + 1).padStart(2, '0')}
          </span>
          <div className="relative h-[1px] w-12 bg-neutral-800">
            <div
              className="absolute top-0 left-0 h-full bg-amber-600 transition-all duration-500"
              style={{ width: `${percentage}%` }}
            ></div>
          </div>
          <span className="bank-gothic text-[10px] text-neutral-600">
            {String(services.length).padStart(2, '0')}
          </span>
        </div>
        <div className="flex self-start space-x-2 sm:self-auto">
          <button
            onClick={prevServiceSlide}
            className="flex h-10 w-10 items-center justify-center border border-neutral-800 transition-colors hover:border-[#c49b66]"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
              <path d="M19 12H5M12 19l-7-7 7-7" />
            </svg>
          </button>
          <button
            onClick={nextServiceSlide}
            className="flex h-10 w-10 items-center justify-center border border-neutral-800 transition-colors hover:border-[#c49b66]"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
          </button>
        </div>
      </div>
    </section>
  );
}

export default ServicesSliderNew;
